import React, { useEffect, useMemo, useState } from "react";
// import "./PersonalDetails.css";
import { toast } from "sonner";
import { CustomModal } from "components/modals/ModalBox";
import { MultiSelect } from "components/form";
import { Select } from "common/InputForm";
import {
  addRecipeApi,
  recipeCollectionListApi,
  recipeDetailApi,
  updateRecipeApi,
} from "services/recipe";

const formTeething = {
  GUMS: "Gum",
  BITE: "Biting",
};

const ManageActivity = ({
  _id,
  type,
  onClose,
  isOpen,
  getListHandler,
  propertyTab,
}) => {
  const isEditable = useMemo(() => type === "EDIT", [type]);
  const [articleCategories, setArticleCategories] = useState([]);
  const [formFields, setFormFields] = useState({
    uploadedImage: null,
    image: "",
    name: "",
    description: "",
    youtubeLink: "",
    status: "",
    isFree: false,
    teething: [],
    complementaryFeeding: [],
    ageGroup: [],
    _collections: [],
  });

  const fetchArticleCategoryData = async () => {
    try {
      const { data } = await recipeCollectionListApi({});
      if (data?.success) {
        setArticleCategories(data?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchData = async () => {
    try {
      const { data } = await recipeDetailApi({ _id });
      if (data?.success) {
        const detail = data?.data;
        console.log({ detail });

        setFormFields((prev) => ({
          ...prev,
          name: detail?.name,
          description: detail?.description,
          status: detail?.status,
          youtubeLink: detail?.youtubeLink,
          isFree: detail?.isFree,
          teething: detail?.recommendations?.teething?.map((item) => ({
            value: item,
            label: formTeething[item],
          })),
          complementaryFeeding:
            detail?.recommendations?.complementaryFeeding?.map((item) => ({
              value: item,
              label: formTeething[item],
            })),
          ageGroup:
            detail?.ageGroup?.map((item) => ({
              value: item,
              label: `${item} Months`,
            })) || [],
          _collections:
            detail?._collections?.map((item) => ({
              value: item._id,
              label: item?.name,
            })) || [],
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchArticleCategoryData();
    if (isEditable) {
      fetchData();
    }

    return () => {
      setFormFields({
        uploadedImage: null,
        image: "",
        name: "",
        description: "",
        youtubeLink: "",
        isFree: false,
        teething: [],
        complementaryFeeding: [],
        ageGroup: [],
        _collections: [],
      });
    };
  }, [isOpen]);

  // onChangeHandler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "number") {
      const numericValue = value.replace(/\D/g, "");
      setFormFields({ ...formFields, number: numericValue });
    } else {
      setFormFields({ ...formFields, [name]: value });
    }
  };

  // Error Handler
  const errorHandler = () => {
    let isValid = true;

    if (!formFields?.name) {
      isValid = false;
      toast.error("Please Enter title");
      return;
    }

    if (!formFields?.description) {
      isValid = false;
      toast.error("Please Enter Description");
      return;
    }

    if (!formFields?._collections) {
      isValid = false;
      toast.error("Please Select Category");
      return;
    }

    // if (!formFields?.youtubeLink) {
    //   isValid = false;
    //   toast.error("Please Enter Youtube Link");
    //   return;
    // }

    if (!formFields?.ageGroup?.length) {
      isValid = false;
      toast.error("Please Select Age Group");
      return;
    }

    if (!formFields?.uploadedImage && !isEditable) {
      isValid = false;
      toast.error("Please Upload Image");
      return;
    }

    return isValid;
  };

  const createRequest = async (status) => {
    if (errorHandler()) {
      try {
        const formData = new FormData();
        const payload = {
          ...formFields,
          language: propertyTab,
          teething: formFields?.teething?.map((item) => item.value),
          complementaryFeeding: formFields?.complementaryFeeding?.map(
            (item) => item.value
          ),
          ageGroup: formFields?.ageGroup?.map((item) => item.value),
          _collections: formFields?._collections?.map((item) => item.value),
          image: formFields?.uploadedImage,
        };

        delete payload?.uploadedImage;

        for (const key in payload) {
          if (
            key === "teething" ||
            key === "complementaryFeeding" ||
            key === "ageGroup" ||
            key === "_collections"
          ) {
            formData.append(key, JSON.stringify(payload[key]));
          } else {
            formData.append(key, payload[key]);
          }
        }

        const { data } = await addRecipeApi(formData);
        if (data?.success) {
          toast.success(data?.message);
          onClose();
          getListHandler();
        } else {
          toast.error(data?.message);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const updateRequest = async (status) => {
    if (errorHandler()) {
      try {
        const formData = new FormData();
        const payload = {
          ...formFields,
          language: propertyTab,
          teething: formFields?.teething?.map((item) => item.value),
          complementaryFeeding: formFields?.complementaryFeeding?.map(
            (item) => item.value
          ),
          ageGroup: formFields?.ageGroup?.map((item) => item.value),
          _collections: formFields?._collections?.map((item) => item.value),
          ...(formFields?.uploadedImage && {
            image: formFields?.uploadedImage,
          }),
        };

        delete payload?.uploadedImage;
        if (payload?.image?.length === 0) {
          delete payload?.image;
        }

        for (const key in payload) {
          if (
            key === "teething" ||
            key === "complementaryFeeding" ||
            key === "ageGroup" ||
            key === "_collections"
          ) {
            formData.append(key, JSON.stringify(payload[key]));
          } else {
            formData.append(key, payload[key]);
          }
        }

        formData.append("_id", _id);
        const { data } = await updateRecipeApi(formData);
        if (data?.success) {
          toast.success(data?.message);
          onClose();
          getListHandler();
        } else {
          toast.error(data?.message);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  // onSubmitHandler
  const onSubmitHandler = async (e, status) => {
    e.preventDefault();

    if (type === "CREATE") {
      createRequest(status);
    } else {
      updateRequest(status);
    }
  };

  console.log({ formFields });

  return (
    <CustomModal className={"lg"} show={isOpen} handleClose={onClose}>
      <div className="personal_details_parents" style={{ padding: 0 }}>
        <div className="personal_form_wrap">
          <h4>{isEditable ? "Update" : "Create"} Recipe </h4>

          <div>
            <button className="button" onClick={(e) => onSubmitHandler(e, "")}>
              {isEditable ? "Update" : "Create"}
            </button>
          </div>
        </div>

        <form>
          <div className="form_field_wrap choose_file">
            <div className="form_field">
              <label htmlFor="fname" className="label">
                Image *
              </label>
              <input
                type="file"
                name="name"
                className="input"
                accept="image/*"
                onChange={(e) =>
                  setFormFields((rev) => ({
                    ...rev,
                    uploadedImage: e.target.files[0],
                  }))
                }
              />
            </div>

            <div className="form_field">
              <label htmlFor="fname" className="label">
                Title *
              </label>
              <input
                type="text"
                name="name"
                className="input"
                onChange={onChangeHandler}
                value={formFields?.name}
              />
            </div>

            {/* <div className="form_field">
                            <label htmlFor="phn_number" className="label">
                                Collection *
                            </label>
                            <Select
                                name="_category"
                                value={formFields?._category}
                                onChange={onChangeHandler}

                            >
                                <option value="" disabled>Select</option>
                                {
                                    articleCategories.map(category => {
                                        return <option value={category?._id} key={category?._id}>{category?.name}</option>
                                    })
                                }
                            </Select>
                        </div> */}

            <div className="form_field">
              <MultiSelect
                label="Collection *"
                Options={articleCategories.map((ele) => ({
                  value: ele._id,
                  label: ele.name,
                }))}
                onChange={(e) =>
                  setFormFields((rev) => ({ ...rev, _collections: e }))
                }
                value={formFields?._collections}
              />
            </div>
          </div>

          <div className="form_field_wrap">
            <div className="form_field">
              <label htmlFor="password" className="label">
                Description *
              </label>
              <textarea
                style={{ resize: "none" }}
                name="description"
                className="input"
                onChange={onChangeHandler}
                value={formFields?.description}
              />
            </div>
            <div className="form_field">
              <label htmlFor="password" className="label">
                Youtube Link
              </label>
              <textarea
                style={{ resize: "none" }}
                name="youtubeLink"
                className="input"
                onChange={onChangeHandler}
                value={formFields?.youtubeLink}
              />
            </div>
            <div className="form_field">
              <MultiSelect
                label="Age Group *"
                Options={[
                  { value: "0-3", label: "0-3 Months" },
                  { value: "4-6", label: "4-6 Months" },
                  { value: "7-9", label: "7-9 Months" },
                  { value: "10-12", label: "10-12 Months" },
                  { value: "13-15", label: "13-15 Months" },
                  { value: "16-18", label: "16-18 Months" },
                  { value: "19-21", label: "19-21 Months" },
                  { value: "22-24", label: "22-24 Months" },
                ]}
                onChange={(e) =>
                  setFormFields((rev) => ({ ...rev, ageGroup: e }))
                }
                value={formFields?.ageGroup}
              />
            </div>
          </div>

          <h5>Recommendations (Optional)</h5>

          <div className="form_field_wrap">
            <div className="form_field">
              <MultiSelect
                label="Teething"
                Options={[
                  { value: "GUMS", label: "Gum" },
                  { value: "BITE", label: "Biting" },
                ]}
                onChange={(e) =>
                  setFormFields((rev) => ({ ...rev, teething: e }))
                }
                value={formFields?.teething}
              />
            </div>
            <div className="form_field">
              <MultiSelect
                label="Complementary Feeding"
                placeholder="select"
                Options={[
                  { value: "GUMS", label: "Gum" },
                  { value: "BITE", label: "Biting" },
                ]}
                onChange={(e) =>
                  setFormFields((rev) => ({ ...rev, complementaryFeeding: e }))
                }
                value={formFields?.complementaryFeeding}
              />
            </div>
          </div>

          <div className="form_field_wrap">
            <label htmlFor="fname" className="label">
              Show in free plan
            </label>
            <input
              type="checkbox"
              name="isFree"
              className="checkbox"
              onChange={e => setFormFields((rev) => ({ ...rev, isFree: e.target.checked }))}
              checked={formFields?.isFree}
            />
            <div className="form_field" />
          </div>
        </form>

        <div className="form_border_bottom"></div>
      </div>
    </CustomModal>
  );
};

export default ManageActivity;
